export default {
  pages: {
    faq: {
      title: "Ko'p so'raladigan savollar(FAQ)",
      searchPlaceholder: 'Izlash',
    },
  },
};
